import script from "./Thumbnail.vue?vue&type=script&setup=true&lang=js"
export * from "./Thumbnail.vue?vue&type=script&setup=true&lang=js"

import "./Thumbnail.vue?vue&type=style&index=0&id=84ebd1d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84ebd1d2"]])

export default __exports__